import { SurveyModel } from "survey-core";

const wrapBareSubstitutions = (text: string): string =>
  text.replace(/(?<!\*)(\{[^{}]+})(?!\*)/g, "*$1*");

/**
 * Enables *italic* markdown in survey titles/descriptions so dynamic
 * answer substitutions can be emphasized, e.g.
 * "When did you last get a *{screen-type}*?"
 *
 * Also wraps bare `{question-name}` placeholders so they italicize
 * even when the template omitted the asterisks.
 */
export const enableSurveyTitleMarkdown = (survey: SurveyModel): void => {
  survey.getAllQuestions().forEach((question) => {
    if (typeof question.title === "string") {
      question.title = wrapBareSubstitutions(question.title);
    }
    if (typeof question.description === "string") {
      question.description = wrapBareSubstitutions(question.description);
    }
  });

  survey.onTextMarkdown.add((_sender, options) => {
    const text = options.text ?? "";
    options.html = text.replace(/\*([^*]+)\*/g, "<em>$1</em>");
  });
};
